import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { HttpClient } from "@angular/common/http";
import { MdbModalRef, MdbModalService } from "mdb-angular-ui-kit/modal";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { windowWhen } from "rxjs";
import { PasswordValidation } from "../reset-pass/validator";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-mentorlogin",
  templateUrl: "./mentorlogin.component.html",
  styleUrls: ["./mentorlogin.component.scss"],
})
export class MentorloginComponent implements OnInit {
  firstFormGroup: FormGroup;
  hide = true;
  filled: any;
  displayStyles = "none";
  constructor(
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}
  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      id: ["", Validators.required],
      password: ["", [Validators.required]],
    });
  }
  username: string = "";
  password: string = "";
  show: boolean = false;
  submit() {
    if (this.firstFormGroup.valid) {
      var body: any = new FormData();
      body.append("mentorid", this.firstFormGroup.value.id);
      body.append("password", this.firstFormGroup.value.password);
      this.displayStyles = "block";
      this.http.post<any>(environment.API_URL + "mentorlogin/", body).subscribe(
        (data) => {
          localStorage.setItem("authTokenmentor", data.token);
          this.displayStyles = "none";
          Swal.fire(data.status);
          this.router.navigate(["/mentordash"]);
        },
        (error) => {
          //Error callback
          console.error(error);
          Swal.fire("Wrong Credentials");
          this.displayStyles = "none";
        }
      );
    } else {
      Swal.fire("Fill all the required details correctly");
    }
  }
  clear() {
    this.firstFormGroup.value.id = "";
    this.firstFormGroup.value.password = "";
    this.show = true;
  }

  register() {
    // this.router.navigateByUrl('/reg')
    Swal.fire("Registration has been Closed!");
  }

  // closePopup() {
  //   this.displayStyle = "none";
  // }
}
